import { apiClient } from '@utils';

export const useForwarder = (id: string) => {
  const result = apiClient.forwarder.retrieveForwarderDetails.useQuery(['forwarder', id], { params: { id } }, { queryKey: ['forwarder', id], enabled: !!id });
  return { ...result, data: result.data?.body?.forwarder };
};
